import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import Rating from "@mui/material/Rating";
import RatingComp from "../../../../../components/Multiple/RatingComp";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AlertContext from "../../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../../Files/BaseURL";
import { formatDateForInput } from "../../../../../Files/UseFunction";
import axios from "axios";
import SocketContext from "../../../../../Context/Socket/SocketContext";
import {
  FaDownload,
  FaFileAlt,
  FaFileImage,
  FaFileVideo,
  FaRegFilePdf,
  FaTimes,
} from "react-icons/fa";
import { BsFiletypeDocx } from "react-icons/bs";
import { MdFolderZip } from "react-icons/md";
import ThemeContext from "../../../../../Context/theme/ThemeContext";

const ServiceDetail = () => {
  const { theme } = useContext(ThemeContext);
  const { id } = useParams();
  const location = useLocation();

  const [Profile, setProfile] = useState(null);
  const [Skills, setSkills] = useState(null);
  const [Portfolio, setPortfolio] = useState(null);
  const [Conversation, setConversation] = useState([]);
  const [TotalPages, setTotalPages] = useState(null);
  const [Page, setPage] = useState(null);
  const [message, setmessage] = useState("");
  const [ChatFile, setChatFile] = useState(null);
  const [FileName, setFileName] = useState(null);
  const [UploadedFile, setUploadedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const scrollContainerRef = useRef(null);

  const navigate = useNavigate();

  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;

  const socketcontext = useContext(SocketContext);
  const { OnlineUsers, SocetConnection, isUserOnline } = socketcontext;
  const [reviews, setReviews] = useState([]);

  const getReviews = async () => {
    try {
      const result = await axios.get(
        `${BaseURL}/api/review/getReviews/${id}/${5}`,
        {
          headers: {
            "auth-token": localStorage.getItem("p@token"),
          },
        }
      );
      if (result.status === 200) {
        setReviews(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchServices = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await fetch(
        `${BaseURL}/api/marektplace/Service/ServiceDetail/${id}`,
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      const data = await response.json();
      setProfile(data.User);
      setSkills(data.Skill);
      setPortfolio(data.Portfolios);
    } catch (error) {
      showAlert("Error fetching Service Skills", "danger");
    }
  };

  const fetchconversation = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/messaging/getMessagesbyuser/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.data.success) {
        setConversation(response.data.messages);
        setTotalPages(response.data.totalPages);
        setPage(response.data.page);
      } else {
        if (response.data.sameuser) {
          setConversation(null);
        } else {
          showAlert(response.data.message, "danger");
        }
      }
    } catch (error) {
      showAlert(error,'danger');
    }
  };

  const scrollToBottom = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop =
        scrollContainerRef.current.scrollHeight;
    }
  };

  const handleSendMessage = async (e) => {
    if (e) e.preventDefault();

    if (id && (message.trim() !== "" || UploadedFile)) {
      try {
        const newMessage = {
          message: message,
          tag: "Sender",
          date: new Date(),
          File: UploadedFile
            ? {
                Link: UploadedFile,
                Name: FileName,
              }
            : null,
        };

        const currentMessage = message;
        const currentFile = {
          Link: UploadedFile,
          Name: FileName,
        };

        setmessage("");
        setUploadedFile(null);
        setFileName(null);
        setChatFile(null);

        setConversation((prev) => [...prev, newMessage]);
        setTimeout(scrollToBottom, 0);

        if (SocetConnection) {
          await SocetConnection.emit("new message", {
            UserID: id,
            covnersation: currentMessage,
            File: currentFile,
          });
        }
      } catch (error) {
        showAlert("Failed to send message", "danger");
        setConversation((prev) => prev.slice(0, -1));
      }
    }
  };

  const FileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      setChatFile(file);
      setFileName(file.name);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("filename", file.name);

      const authToken = localStorage.getItem("p@token");
      const response = await fetch(`${BaseURL}/api/messaging/upload-docs`, {
        method: "POST",
        headers: {
          "auth-token": authToken,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setUploadedFile(data?.location);
      } else {
        showAlert("File not uploaded, try again", "danger");
      }
    } catch (error) {
      console.error("File upload error:", error);
      showAlert("File not uploaded, try again", "danger");
    }
  };

  const renderFileIcon = (file) => {
    const fileType = file;

    console.log(file);
    switch (fileType) {
      case "image":
        return <FaFileImage className="text-2xl w-full text-primarygreen" />;
      case "video":
        return <FaFileVideo className="text-2xl w-full text-primarygreen" />;
      case "pdf":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "application":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "doc":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "docx":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "zip":
        return <MdFolderZip className="text-2xl w-full text-gray-400" />;
      default:
        return <FaFileAlt className="text-2xl w-full text-primarygreen" />;
    }
  };

  const handleScroll = useCallback(
    (e) => {
      const container = e.target;
      if (container.scrollTop <= 100 && !isLoading) {
        if (id && Page < TotalPages) {
          loadMoreMessages(id, Page + 1);
        }
      }
    },
    [Page, TotalPages, isLoading, id]
  );

  const loadMoreMessages = useCallback(
    async (userId, pageNumber) => {
      if (isLoading || pageNumber > TotalPages) return;

      try {
        setIsLoading(true);
        const scrollContainer = scrollContainerRef.current;
        const previousHeight = scrollContainer?.scrollHeight || 0;

        const authToken = localStorage.getItem("p@token");
        const response = await axios.get(
          `${BaseURL}/api/messaging/getMessagesbyuser/${userId}?page=${pageNumber}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "auth-token": authToken,
            },
          }
        );

        if (response.data.success) {
          setConversation((prevMessages) => [
            ...response.data.messages,
            ...prevMessages,
          ]);
          setTotalPages(response.data.totalPages);
          setPage(response.data.page);

          setTimeout(() => {
            if (scrollContainer) {
              const newHeight = scrollContainer.scrollHeight;
              scrollContainer.scrollTop = newHeight - previousHeight;
            }
          }, 0);
        }
      } catch (error) {
        showAlert(error.message, "danger");
      } finally {
        setIsLoading(false);
      }
    },
    [isLoading, TotalPages, showAlert]
  );

  useEffect(() => {
    if (id) {
      fetchServices();
      fetchconversation();
      getReviews();
    }
  }, [id]);

  useEffect(() => {
    if (SocetConnection) {
      const handleMessage = (data) => {
        fetchconversation();

        setTimeout(scrollToBottom, 100);
      };

      SocetConnection.on("message", handleMessage);
      return () => {
        SocetConnection.off("message", handleMessage);
      };
    }
  }, [SocetConnection, id]);

  useEffect(() => {
    if (Conversation?.length > 0) {
      scrollToBottom();
    }
  }, [Conversation]);

  return (
    <div className="w-[95%] m-auto py-6 flex flex-col gap-6">
      <div className="flex flex-col lg:flex-row gap-6">
        <div
          className={`basis-[70%]  flex flex-col gap-6 rounded-2xl py-6 px-4 ${
            theme == "dark" ? "bg-black text-white" : "bg-white "
          }`}
        >
          <div className="flex flex-col lg:flex-row justify-between gap-6 lg:gap-2">
            <div className="flex flex-col md:flex-row font-pop items-center gap-2">
              <div>
                {Profile?.ProfilePhoto ? (
                  <img
                    src={Profile?.ProfilePhoto}
                    alt=""
                    className="rounded-full w-8 md:w-12 h-8 md:h-12"
                  />
                ) : (
                  <div className="w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center">
                    <span className={`text-white `}>
                      {Profile && Profile?.FirstName?.charAt(0)}
                    </span>
                  </div>
                )}
              </div>

              <div className="flex flex-col gap-1 md:gap-2">
                <div className="flex flex-row gap-1 items-center">
                  <img
                    src="../../../Assets/Prop/badge.png"
                    className="w-6 h-6"
                  />
                  <h4
                    className={`text-base text-lightGrey ${
                      theme == "dark" && "text-white"
                    }`}
                  >
                    Level {Profile?.Level}
                  </h4>
                </div>
                <h3 className="text-2xl font-semibold">
                  {Profile?.FirstName} {Profile?.LastName}
                </h3>
                <h4
                  className={`text-lg text-lightGrey   ${
                    theme == "dark" && "text-white"
                  }`}
                >
                  @{Profile?.FirstName}
                  {Profile?.LastName}
                </h4>
              </div>
            </div>
            <div className="flex flex-col lg:text-right font-pop gap-2">
              <h2
                className={` text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                <span className="font-light">Last seen: </span>5 hours ago
              </h2>
              <h2
                className={` text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                <span className="font-light">Local time: </span>United Kingdom,
                10 Mar 2024, 19:24
              </h2>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex flex-col font-pop gap-1">
              <h4
                className={`text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                Location
              </h4>
              <h3 className="font-normal">{Profile?.Homeaddress?.Country}</h3>
            </div>
            <div className="flex flex-col font-pop gap-1">
              <h4
                className={` text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                Skills
              </h4>
              <div className="flex flex-row flex-wrap font-pop gap-1">
                {Skills?.map((item, index) => (
                  <div
                    className={` rounded-full py-1 px-2 text-base ${
                      theme == "dark" ? "bg-black text-white" : "bg-white "
                    } `}
                    key={index}
                  >
                    {item?.name}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col font-pop gap-1">
              <h4
                className={` text-lightGrey font-medium    ${
                  theme == "dark" && "text-white"
                }`}
              >
                Languages
              </h4>
              {Profile?.Languages.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-row flex-wrap font-pop gap-1"
                >
                  <div
                    className={`rounded-full py-1 px-2 text-base ${
                      theme === "dark" ? "bg-black text-white" : "bg-white"
                    }`}
                  >
                    {item}
                  </div>
                </div>
              ))}
              {/*                            <div className="flex flex-row flex-wrap font-pop gap-1">*/}
              {/*                                <div className={` rounded-full py-1 px-2 text-base*/}
              {/*                                 ${theme == "dark" ? "bg-black text-white" : "bg-white "*/}
              {/*                                    } */}
              {/*`}>*/}
              {/*                                    English*/}
              {/*                                </div>*/}
              {/*                                <div className={` rounded-full py-1 px-2 text-base*/}
              {/*                                 ${theme == "dark" ? "bg-black text-white" : "bg-white "*/}
              {/*                                    } */}
              {/*`}>*/}
              {/*                                    Urdu*/}
              {/*                                </div>*/}
              {/*                            </div>*/}
            </div>
            <div className="flex flex-col font-pop gap-1">
              <h4
                className={` text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                Rating
              </h4>
              <div
                className={` bg-[#FEF8EE] font-medium py-1 px-2 h-fit w-fit flex flex-row items-center gap-2 text-black rounded-3xl ${
                  theme == "dark" ? "bg-black text-white" : "bg-white "
                }`}
              >
                {Number(Profile?.Rating).toFixed(1)}{" "}
                <Rating
                  name="read-only"
                  precision={0.1}
                  value={Number(Profile?.Rating)}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`basis-[30%] flex flex-col justify-between gap-4 rounded-2xl py-6 px-2 ${
            theme == "dark" ? "bg-black text-white" : "bg-white "
          }`}
        >
          <h3
            className={`border-b-2 border-light text-center pb-4 text-lightGrey font-pop ${
              theme == "dark" && "text-white"
            }`}
          >
            Latest reviews for this seller
          </h3>
          <div className="flex flex-col font-pop gap-2 max-h-72 overflow-y-auto py-4">
            {reviews &&
              reviews?.map((item, index) => (
                <RatingComp
                  key={index}
                  FirstName={item?.reviewedBy.FirstName}
                  LastName={item?.reviewedBy.LastName}
                  ProfileImage={item?.reviewedBy.ProfilePhoto}
                  Country={item?.reviewedBy.Homeaddress.Country}
                  rating={item?.rating}
                  reviewMessage={item?.review}
                  date={item?.date}
                />
              ))}
          </div>
          <div
            className="border-2 font-pop w-full text-center font-medium border-light py-2 px-4 rounded-full"
            onClick={() => {
              navigate(`/user-dashboard/rating/${id}`);
            }}
          >
            See all Reviews
          </div>
        </div>
      </div>
      <div
        className={` rounded-2xl  py-6 px-6 ${
          theme == "dark" ? "bg-black text-white" : "bg-white  text-gray-400"
        } `}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Portfolio?.map((item, index) => (
            <div
              className="rounded-2xl relative cursor-pointer"
              onClick={() => {
                navigate(
                  `/user-dashboard/service/serviceportfolio/${id}/${item._id}`
                );
              }}
              key={index}
            >
              <img
                src={item?.Images[0]?.img}
                alt=""
                className="h-60 w-full rounded-2xl object-cover bg-gray-200"
              />
              <div className="bg-black/25 absolute bottom-0 w-full py-2 px-4 font-pop text-white rounded-b-2xl">
                <h2>{item?.Title}</h2>
              </div>
            </div>
          ))}
        </div>
      </div>
      {Conversation !== null && (
        <div
          className={`rounded-2xl py-6 px-6 ${
            theme == "dark" ? "bg-black text-white" : "bg-white text-black"
          }`}
        >
          <div className="flex flex-col gap-6 h-[100%] justify-between max-w-full">
            <div
              className="flex flex-col gap-2 h-[60vh] overflow-y-auto scrollbar-hide overflow-x-hidden"
              ref={scrollContainerRef}
              onScroll={handleScroll}
              style={{
                msOverflowStyle: "none",
                scrollbarWidth: "none",
              }}
            >
              {isLoading && (
                <div className="text-center py-2">
                  <p>Loading previous messages...</p>
                </div>
              )}
              <div className="flex flex-col gap-2">
                {Conversation?.length > 0 &&
                  Conversation?.map((item, index) => (
                    <div
                      key={index}
                      className={`${
                        item.tag == "Sender"
                          ? "flex flex-col justify-end items-end"
                          : "flex flex-col justify-start items-start"
                      } my-1 gap-1 w-full`}
                    >
                      {item?.File?.Link && (
                        <div
                          className={`p-2 rounded w-fit shadow-md font-pop flex items-end ${
                            item.tag == "Sender"
                              ? "bg-primarygreen/50 self-end text-white"
                              : "bg-gray-300"
                          }`}
                        >
                          <div className="flex flex-col gap-2">
                            {item?.File && renderFileIcon(item?.File?.Link)}
                            <span className="ml-2">{item?.File?.Name}</span>
                          </div>
                          <a
                            href={item?.File?.Link}
                            download={true}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaDownload className="ml-2 text-3xl text-gray-500 cursor-pointer" />
                          </a>
                        </div>
                      )}
                      <div
                        className={`${
                          item.tag == "Sender"
                            ? "bg-primarygreen text-white"
                            : "bg-[#E8E8E8]"
                        } rounded-xl py-2 px-4 max-w-[85%] md:max-w-[75%] lg:max-w-[65%] break-words`}
                      >
                        <p className="text-sm md:text-base whitespace-pre-wrap break-words overflow-hidden">
                          {item?.message}
                        </p>
                      </div>
                      <p
                        className={`${
                          item.tag == "Sender" ? "text-right" : "text-left"
                        } text-xs w-full`}
                      >
                        {formatDateForInput(item?.date)}
                      </p>
                    </div>
                  ))}
              </div>
            </div>

            {/* Message Input Section */}
            <div
              className={`flex flex-row font-pop justify-between items-center rounded-3xl py-2 px-4 ${
                theme == "dark" ? "bg-black text-white" : "bg-[#E8E8E8]"
              }`}
            >
              <div className="flex w-[100%] flex-row items-center gap-2">
                <label htmlFor="fileupload" className="relative cursor-pointer">
                  <img
                    src="../../../../../Assets/Prop/docattach.png"
                    alt="Upload"
                    className="w-8 h-8"
                  />
                  <input
                    type="file"
                    id="fileupload"
                    className="hidden"
                    onChange={FileUpload}
                  />
                </label>

                <div className="flex gap-2 w-full">
                  {UploadedFile && (
                    <div
                      className={`p-2 rounded shadow-md font-pop flex items-center ${
                        theme == "dark" ? "bg-gray-700" : "bg-gray-300"
                      }`}
                    >
                      <div className="flex flex-col gap-2">
                        {ChatFile && renderFileIcon(ChatFile)}
                        <span className="ml-2 w-max text-xs">{FileName}</span>
                      </div>
                      <FaTimes
                        className="ml-2 text-red-500 cursor-pointer"
                        onClick={() => {
                          setChatFile(null);
                          setFileName(null);
                          setUploadedFile(null);
                        }}
                      />
                    </div>
                  )}
                  <input
                    type="text"
                    value={message}
                    onChange={(e) => setmessage(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSendMessage(e);
                      }
                    }}
                    placeholder="Message..."
                    className="text-lg w-[100%] font-normal border-transparent outline-none focus:outline-none focus:border-transparent active:border-transparent active:outline-none bg-transparent"
                  />
                </div>
              </div>
              <img
                src="../../../../../Assets/Prop/messagesend.png"
                alt="Send message"
                onClick={handleSendMessage}
                className="w-8 h-8 cursor-pointer"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceDetail;
